// app/frontend/utils/navegacion.js

export function inicializarNavegacionPorDataLink() {
  document.querySelectorAll('[data-link]').forEach(element => {
    element.addEventListener('click', () => {
      const url = element.dataset.link
      if (url) window.location.href = url
    })
  })
}